import { render, staticRenderFns } from "./issueReadonlyContents.vue?vue&type=template&id=06714cf6&"
import script from "./issueReadonlyContents.vue?vue&type=script&lang=ts&"
export * from "./issueReadonlyContents.vue?vue&type=script&lang=ts&"
import style0 from "./issueReadonlyContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports